__turbopack_context__.v({
  "container": "ErrorTemplate-module-scss-module__s_AeOa__container",
  "content": "ErrorTemplate-module-scss-module__s_AeOa__content",
  "errorTemplate": "ErrorTemplate-module-scss-module__s_AeOa__errorTemplate",
  "main": "ErrorTemplate-module-scss-module__s_AeOa__main",
  "textContent": "ErrorTemplate-module-scss-module__s_AeOa__textContent",
  "wrap": "ErrorTemplate-module-scss-module__s_AeOa__wrap",
});
